var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable
import "pixi.js";
import "pixi-spine";
// tslint:enable
import { BehaviorSubject, fromEvent, merge } from "rxjs";
import { debounceTime, switchMap } from "rxjs/operators";
import { IdPersistence } from "../../constants/IdPersistence";
import { resize$ } from "../../events/eventsBrowser";
import { eventsCanvas } from "../../events/eventsCanvas";
import { eventsViewport } from "../../events/eventsViewport";
import { utilGrid } from "../../utils/grid/utilGrid";
import { IdSoundGroup } from "../../utils/sound/IdSoundGroup";
import { utilSound } from "../../utils/sound/utilSound";
import { utilPersistence } from "../../utils/utilPersistence";
import { StateWindowVisibility } from "../../utils/window-visibility/StateWindowVisibility";
import { utilWindowVisibility } from "../../utils/window-visibility/utilWindowVisibility";
import { SceneManagerCanvas } from "../scenes/SceneManagerCanvas";
var Application = PIXI.Application;
var Spine = PIXI.spine.Spine;
var Options = {
    antialias: false,
    autoResize: true,
    autoStart: false,
    backgroundColor: 0xa7ca4d,
    height: screen.height,
    powerPreference: "high-performance",
    preserveDrawingBuffer: false,
    resolution: window.devicePixelRatio || 1,
    roundPixels: false,
    view: document.getElementById("canvas-main"),
    width: screen.width,
};
var AppCanvas = /** @class */ (function (_super) {
    __extends(AppCanvas, _super);
    function AppCanvas() {
        var _this = _super.call(this, Options) || this;
        _this.viewportChange$ = new BehaviorSubject(undefined);
        _this.started = false;
        // setup RAF
        _this.then = Date.now();
        _this.startUpdate = function (targetFps) {
            if (targetFps === void 0) { targetFps = 60; }
            _this.fpsInterval = 1000 / targetFps;
            _this.then = Date.now();
            _this.animate();
        };
        _this.removeUpdate = function () {
            cancelAnimationFrame(_this.requestAnimationFrameId);
        };
        _this.onResize = function () { return _this.renderer.resize(window.innerWidth, window.innerHeight); };
        _this.onVisibilityChange = function (state) {
            if (state === StateWindowVisibility.Hidden) {
                _this.onLoseFocus();
            }
            else {
                // Handling both, pre-render and visible
                _this.onGainFocus();
            }
        };
        _this.onLoseFocus = function () {
            Spine.globalAutoUpdate = false;
            utilSound.muteSoundGroup(IdSoundGroup.Global, true);
            _this.removeUpdate();
        };
        _this.onGainFocus = function () {
            var fpsLimit = utilPersistence.getValue(IdPersistence.AnimationSettings, { fpsLimit: 60 }).fpsLimit;
            _this.startUpdate(fpsLimit);
            Spine.globalAutoUpdate = true;
            utilSound.muteSoundGroup(IdSoundGroup.Global, false);
        };
        _this.animate = function () {
            _this.requestAnimationFrameId = requestAnimationFrame(_this.animate);
            var now = Date.now();
            var elapsed = now - _this.then;
            if (elapsed > _this.fpsInterval) {
                _this.then = now - (elapsed % _this.fpsInterval);
                _this.ticker.update(_this.then);
            }
        };
        eventsCanvas.setup(_this.renderer.plugins.interaction);
        resize$.subscribe(_this.onResize);
        utilWindowVisibility.visibility$.subscribe(_this.onVisibilityChange);
        return _this;
    }
    AppCanvas.prototype.setup = function (gridConfig, assetConfig) {
        utilGrid.setup(gridConfig);
        this.assetConfig = assetConfig;
    };
    AppCanvas.prototype.start = function () {
        var _this = this;
        _super.prototype.start.call(this);
        if (!this.started) {
            this.started = true;
            this.ticker.stop();
            this.ticker.speed = 0.5;
            this.startUpdate();
            if (this.stage.children.length > 0) {
                this.stage.children.forEach(function (child) { return child.destroy(true); });
            }
            var sceneManager_1 = new SceneManagerCanvas();
            this.stage.addChild(sceneManager_1);
            var onChildAdded = fromEvent(sceneManager_1, "child-added").pipe(debounceTime(1));
            merge(onChildAdded.pipe(switchMap(function () { return eventsViewport.createViewportEvent$(sceneManager_1, "moved"); })), onChildAdded.pipe(switchMap(function () { return eventsViewport.createViewportEvent$(sceneManager_1, "zoomed"); }))).subscribe(function (viewport) { return _this.viewportChange$.next(viewport); });
            if (this.assetConfig != undefined) {
                var interactionManager = this.renderer.plugins.interaction;
                interactionManager.cursorStyles.pointer = "url(" + this.assetConfig.cursorUrl + "), pointer";
            }
        }
    };
    return AppCanvas;
}(Application));
// Set FPS to 30
PIXI.settings.TARGET_FPMS = 0.03;
PIXI.settings.UPLOADS_PER_FRAME = 2;
PIXI.ticker.shared.autoStart = false;
PIXI.ticker.shared.stop();
PIXI.utils.skipHello();
export var appCanvas = new AppCanvas();



//////////////////
// WEBPACK FOOTER
// ./src/features/app/appCanvas.ts
// module id = 407
// module chunks = 3